import styled from 'styled-components';
import { createTypography } from 'utils';

export const H1 = styled.h1`
  ${createTypography('h1', 'md')}
  margin: 0;
  color: ${({ theme }) => theme.palette.blackLighten5};

  ${({ theme }) => theme.breakpoints.maxMobile} {
    ${createTypography('h1', 'sm')};
    color: ${({ theme }) => theme.palette.blackLighten5};
  }
`;

export const H2 = styled.h2`
  ${createTypography('h2', 'md')}
  margin: 0;
  color: ${({ theme }) => theme.palette.blackLighten5};

  ${({ theme }) => theme.breakpoints.maxMobile} {
    ${createTypography('h2', 'sm')};
    color: ${({ theme }) => theme.palette.blackLighten5};
  }
`;

export const H3 = styled.h3`
  ${createTypography('h3', 'md')}
  color: ${({ theme }) => theme.palette.blackLighten5};
`;
